var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCpayTourSidebar = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43268 17.6223L7.37916 13.3008H2.88337C2.88337 13.3008 2.47194 15.0294 3.75098 16.4987C4.72902 17.6222 6.43268 17.6223 6.43268 17.6223Z",
    fill: "#CD081E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43268 17.6223L7.37916 13.3008H2.88337C2.88337 13.3008 2.47194 15.0294 3.75098 16.4987C4.72902 17.6222 6.43268 17.6223 6.43268 17.6223Z",
    fill: "url(#paint0_linear_10231_118377)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8856 2.2373H12.1909C14.8045 2.2373 16.9233 4.55908 16.9233 7.42312V8.11457C16.9233 10.9786 14.8045 13.3004 12.1909 13.3004H7.3796H2.88379L3.53945 10.0159H7.08035C8.12582 10.0159 8.9733 9.08722 8.9733 7.94162C8.9733 6.79598 8.12582 5.86728 7.08035 5.86728H4.36762L4.49532 5.22757C4.84384 3.4817 6.2547 2.2373 7.8856 2.2373Z",
    fill: "url(#paint1_linear_10231_118377)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36444 5.86621H7.07835C8.12382 5.86621 8.9713 6.79492 8.9713 7.94056C8.9713 9.08616 8.12382 10.0149 7.07835 10.0149H3.53711L4.36444 5.86621Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23743 8.63387C7.58592 8.63387 7.86842 8.3243 7.86842 7.94242C7.86842 7.56055 7.58592 7.25098 7.23743 7.25098C6.88895 7.25098 6.60645 7.56055 6.60645 7.94242C6.60645 8.3243 6.88895 8.63387 7.23743 8.63387Z",
    fill: "#2196F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10231_118377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 15,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8856 2.2373H12.1909C14.8045 2.2373 16.9233 4.55908 16.9233 7.42312V8.11457C16.9233 10.9786 14.8045 13.3004 12.1909 13.3004H7.37959H2.88379L3.53945 10.0159H7.08035C8.12582 10.0159 8.9733 9.08722 8.9733 7.94162C8.9733 6.79598 8.12582 5.86728 7.08035 5.86728H4.36762L4.49532 5.22757C4.84384 3.4817 6.2547 2.2373 7.8856 2.2373Z",
    fill: "url(#paint2_linear_10231_118377)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10231_118377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2849 9.1815C10.9016 8.89712 10.7099 9.35212 10.919 9.57962C11.616 10.338 12.5105 10.8688 12.8706 11.0394C13.7628 11.5247 15.1591 11.5829 15.7457 11.5513C16.0106 11.3389 16.4079 10.6602 16.5473 10.2811C15.3798 10.6982 13.5432 10.3776 12.9759 10.1947C12.5054 10.043 11.6566 9.47851 11.2849 9.1815Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10231_118377",
    x1: 5.34427,
    y1: 13.3008,
    x2: 6.07437,
    y2: 18.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A95F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30C0F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10231_118377",
    x1: 16.8605,
    y1: 2.2373,
    x2: 6.09302,
    y2: 15.8406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A78F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10231_118377",
    x1: 16.8605,
    y1: 2.2373,
    x2: 6.09302,
    y2: 15.8406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A78F5"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCpayTourSidebar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cpayTourSidebar.c14c032a.svg";
export { ForwardRef as ReactComponent };